import { Modal } from 'antd';

import { ModalContentComponent } from './ModalContentComponent';

import { useUploadConfirmModal } from '@/store/ui-preferences';

interface ShowConfirmUploadModalParams {
  title: string;
  description: string;
  dontShowAgainLabel: string;
  okText: string;
  cancelText: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

export const showConfirmUploadModal = ({
  title,
  description,
  dontShowAgainLabel,
  okText,
  cancelText,
  onConfirm,
  onCancel
}: ShowConfirmUploadModalParams) => {
  let dontShowAgainChecked = false;

  Modal.confirm({
    title: null,
    icon: null,
    content: (
      <ModalContentComponent
        title={title}
        description={description}
        dontShowAgainLabel={dontShowAgainLabel}
        onCheckChange={checked => (dontShowAgainChecked = checked)}
      />
    ),
    okText,
    cancelText,
    centered: true,
    width: 530,
    onOk: () => {
      if (dontShowAgainChecked) {
        useUploadConfirmModal.getState().setDontShowAgain(true);
      }
      onConfirm();
    },
    onCancel
  });
};
